import User from '@/models/User';
import * as types from './mutation-types';

// export const setStopwatchTime = ({ commit }, time) => {
//   commit(types.SET_STOPWATCH_TIME, time);
// };

export const startWorkTime = ({ commit, dispatch }) => {
  dispatch('wait/start', 'check loading', { root: true });
  return (new User({
    id: 'check-in',
  }))
    .save()
    .then((response) => {
      commit(types.SET_WORK_TIME, response.work_time.check_in_date_time);
      commit(types.SET_WORK_TIME_ID, response.work_time.id);
      dispatch('wait/end', 'check loading', { root: true });
    });
};

export const stopWorkTime = ({ commit, dispatch }) => {
  dispatch('wait/start', 'check loading', { root: true });
  return (new User({
    id: 'check-out',
  }))
    .save()
    .then(() => {
      commit(types.SET_WORK_TIME, null);
      commit(types.SET_WORK_TIME_ID, null);
      dispatch('wait/end', 'check loading', { root: true });
    });
};

export const resetWorkTime = ({ commit, state, dispatch }) => {
  dispatch('wait/start', 'check loading', { root: true });
  return (new User({
    id: `check-out/${state.workTimeId}`,
  }))
    .save()
    .then(() => {
      commit(types.SET_WORK_TIME, null);
      commit(types.SET_WORK_TIME_ID, null);
      dispatch('wait/end', 'check loading', { root: true });
    });
};

export const checkWorkTime = ({ commit }) => {
  commit(types.CHECK_WORK_TIME);
};

export const updateCredit = ({ commit }, payload) => {
  commit(types.UPDATE_CREDIT, payload);
};

export default {
  startWorkTime,
  stopWorkTime,
  resetWorkTime,
  updateCredit,
  checkWorkTime,
};



// WEBPACK FOOTER //
// ./src/store/modules/common/actions.js